export default __webpack_public_path__ + "e15f915e10b32d72e16bf123b5452a33.png";